import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { notify } from '../../../toaster';
import { GET_COMMENTS_QUERY_KEY } from '../../core';

const MUTATION_KEY_DELETE_NOTE = 'delete-note';

export const useDeleteNote = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationKey: [MUTATION_KEY_DELETE_NOTE] as const,
    mutationFn: (id: number) => api.request(endpoints.notes.deleteNote(id)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_COMMENTS_QUERY_KEY],
      });
      notify.default({
        title: intl.formatMessage({
          id: 'components.documentComments.toast.deleteSuccess',
        }),
      });
    },
    onError: () =>
      notify.error({
        title: intl.formatMessage({
          id: 'components.documentComments.toast.deleteError',
        }),
      }),
  });
};
